import { render, staticRenderFns } from "./LockedResource.vue?vue&type=template&id=45bc388e&"
import script from "./LockedResource.vue?vue&type=script&lang=ts&"
export * from "./LockedResource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports